<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>临时抓取任务</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      临时抓取任务
      <div class="title-btn">
        <el-button
          type="primary"
          plain
          @click="goImportTask"
          v-if="$store.state.funcModuleArray.includes(1901010301)"
          >批量导入任务</el-button>
        <el-button
          type="primary"
          plain
          @click="goCreateTask"
          v-if="$store.state.funcModuleArray.includes(1901010301)"
          >创建任务</el-button>
        <el-button
          type="primary"
          plain
          @click="goNewTakse"
          v-if="$store.state.funcModuleArray.includes(1901010301)"
          >SQL新增任务</el-button
        >
      </div>
    </h1>
    <div class="view-content">
      <el-card class="box-card">
        <div class="view-filter">
          <el-form :inline="true" size="small" label-suffix="：">
            <el-form-item label="状态筛选">
              <el-select v-model="form.status" placeholder="选择状态">
                <el-option
                  v-for="(item, index) in statusList"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="报告类型">
              <el-select v-model="form.report_type" placeholder="报告类型">
                <el-option
                  v-for="(item, index) in reportList"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-if=" $store.state.companyInfo.account_row.show_file_diff==1" label="是否对比差异">
              <el-select size="small" v-model="form.is_diff">
                <el-option label="全部" value=""></el-option>
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="任务类型">
              <el-select v-model="form.scrap_time_type" placeholder="任务类型">
                <el-option label="全部" value=""></el-option>
                <el-option label="实时" value="1"></el-option>
                <el-option label="定时" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="form.search_text"
                class="search-text"
                size="small"
                placeholder="请输入编码或名称"
              >
                <el-button slot="append" @click="onSearch">查找</el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="card-content">
          <div style="display: flex; justify-content: space-between">
            <div class="table-tool">共{{ totalCount }}条</div>
            <div class="count_page">
              每页
              <el-select
                style="width: 70px"
                v-model="form.page_size"
                @change="onSearch"
              >
                <el-option label="20" value="20"></el-option>
                <el-option label="50" value="50"></el-option>
                <el-option label="100" value="100"></el-option> </el-select
              >条
            </div>
          </div>
          <el-table
            :data="tableData"
            v-loading="tableDataLoading"
            style="width: 100%"
          >
            <el-table-column
              prop="grab_code"
              label="任务编码"
            ></el-table-column>
            <el-table-column
              prop="plugin_code"
              label="插件编码"
            ></el-table-column>
            <el-table-column
              prop="client_code"
              label="经销商编码"
            ></el-table-column>
            <el-table-column
              prop="client_name"
              label="经销商名称"
              width="200"
            >
              <template slot-scope="scope">
                <div style="display: flex; align-items: center;">
                  <span style="word-break: break-all; word-wrap: break-word;">
                    {{ scope.row.client_name }}
                  </span>
                  <el-tooltip 
                    v-if="scope.row.scrap_time && scope.row.status == 9"
                    :content="`定时采集时间：${scope.row.scrap_time}`" 
                    placement="top"
                  >
                    <img 
                      src="@/assets/img/timed_collection_time.png"
                      style="width: 16px; height: 16px; margin-left: 4px; flex-shrink: 0;"
                    />
                  </el-tooltip>
                  <el-tag 
                    v-if="scope.row.is_new === 1"
                    class="new-tag"
                    size="small"
                  >新</el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="report_type_label"
              label="报告类型"
            ></el-table-column>

            <el-table-column prop="is_diff" v-if=" $store.state.companyInfo.account_row.show_file_diff==1" label="是否对比差异">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.is_diff == 1 ? "是" : "否" }}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="opreate_name" label="操作人">
            </el-table-column>

            <el-table-column prop="create_time"  width="160" label="操作时间">
            </el-table-column>

            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                <div slot="reference" class="name-wrapper">
                  <el-tag
                    size="medium"
                    type="info"
                    v-if="scope.row.status === 0"
                    >等待中</el-tag
                  >
                  <el-tag
                    size="medium"
                    type="info"
                    v-if="scope.row.status === 1"
                    >处理中</el-tag
                  >
                  <el-tag
                    size="medium"
                    type="success"
                    v-if="scope.row.status === 3"
                    >已完成</el-tag
                  >
                  <el-tooltip
                    v-if="scope.row.status === 4"
                    effect="dark"
                    :content="scope.row.error_msg"
                    :disabled="
                      !scope.row.error_msg || scope.row.error_msg === ''
                    "
                    placement="top"
                  >
                    <el-tag size="medium" type="warning">sql语句有误</el-tag>
                  </el-tooltip>
                  <el-tag
                    size="medium"
                    type="danger"
                    v-if="scope.row.status === 5"
                    >文件上传失败</el-tag
                  >
                  <el-tag
                    size="medium"
                    type="danger"
                    v-if="scope.row.status === 6"
                    >数据库未调通</el-tag
                  >
                  <el-tag
                    size="medium"
                    type="info"
                    v-if="scope.row.status === 7"
                    >取消任务</el-tag
                  >
                  <el-tag
                    size="medium"
                    type="warning"
                    v-if="scope.row.status === 9"
                    >计划中</el-tag
                  >
                  <el-tag
                    size="medium"
                    type="danger"
                    v-if="scope.row.status === 8"
                    >抓取失败</el-tag
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="operate"
              width="220"
              label="操作"
              v-if="
                $store.state.funcModuleArray.includes(1901010302) ||
                $store.state.funcModuleArray.includes(1901010303) ||
                $store.state.funcModuleArray.includes(1901010304)
              "
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="viewSql(scope.$index, scope.row)"
                  type="text"
                  size="small"
                  v-if="$store.state.funcModuleArray.includes(1901010302)"
                  >查看SQL</el-button
                >
                <el-button
                  @click.native.prevent="viewFile(scope.$index, scope.row)"
                  type="text"
                  size="small"
                  v-if="$store.state.funcModuleArray.includes(1901010303)"
                  >查看文件</el-button
                >
                <el-button
                  v-if="
                    scope.row.can_cancel === 1 &&
                    $store.state.funcModuleArray.includes(1901010304)
                  "
                  @click="onStopDialog(scope.row.temporary_grab_id)"
                  type="text"
                  size="small"
                  >取消任务</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>

      <div class="block" v-if="totalPage > 1">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="Number(form.page_size)"
          layout="total, prev, pager, next, jumper"
          :total="totalCount"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="提示!" :visible.sync="stopDialog" width="30%">
      <span>确认取消该任务？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="stopDialog = false">取 消</el-button>
        <el-button type="primary" @click="confirmStopDialog" :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 添加直连历史月采集任务弹窗 -->
    <el-dialog
      title="直连历史月采集任务"
      :visible.sync="createTaskDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      @open="handleDialogOpen"
    >
      <el-form :model="createTaskForm" label-width="120px" :rules="rules" ref="createTaskForm">
        <el-form-item label="采集对象" prop="collectTargets">
          <el-button type="primary" @click="openSelectDealer">选择</el-button>
          <div class="selected-dealers">
            <el-tag
              v-for="dealer in selectedDealers"
              :key="dealer.client_id"
              closable
              @close="handleRemoveDealer(dealer)"
              style="margin-right: 10px;"
            >
              {{ dealer.client_name }}
            </el-tag>
          </div>
        </el-form-item>

        <el-form-item label="采集月份" prop="collectMonth">
          <el-date-picker
            v-model="createTaskForm.collectMonth"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            value-format="yyyy-MM"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="数据类型" prop="dataTypes">
          <el-checkbox-group v-model="createTaskForm.dataTypes">
            <el-checkbox label="sales">销售月报</el-checkbox>
            <el-checkbox label="purchase">采购月报</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="任务类型" prop="taskType">
          <el-radio-group v-model="createTaskForm.taskType" @change="handleTaskTypeChange">
            <el-radio label="realtime">实时</el-radio>
            <el-radio label="scheduled">定时</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item 
          label="定时采集时间" 
          prop="scheduledTime"
          v-if="createTaskForm.taskType === 'scheduled'"
        >
          <el-date-picker
            v-model="createTaskForm.scheduledTime"
            type="datetime"
            placeholder="选择日期时间"
            :picker-options="scheduledTimeOptions"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-checkbox v-model="createTaskForm.splitFile">
            拆分文件
          </el-checkbox>

          <el-checkbox 
            v-model="createTaskForm.compareData" 
            v-if="showCompareDataOption"
          >
            对比差异
          </el-checkbox> 
        </el-form-item>
       
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="createTaskDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitCreateTask">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加组件引用 -->
    <select-collect-target-modal
      ref="selectCollectTargetModal"
      @on-success="handleDealerSelected"
    />
  </div>
</template>

<script>
import { getqueryPageList, enumBusinessList, stopTemporary, multipleAddTemporary, adminTemporaryDownloadTempFile } from "@/api/index";
import SelectCollectTargetModal from '@/components/SelectCollectTargetModal.vue';

export default {
  name: "TempSnatchTask",
  components: {
    SelectCollectTargetModal
  },
  data: () => ({
    currentPage: 1,
    totalCount: 0,
    totalPage: 0,
    tableData: [],
    statusList: [],
    reportList: [],
    form: {
      status: -1,
      report_type: 0,
      search_text: "",
      page_size: 20,
      is_diff: "",
      scrap_time_type: ""
    },
    tableDataLoading: false,
    stopDialog: false,
    temporaryGrabId: 0,
    createTaskDialogVisible: false,
    createTaskForm: {
      collectTargets: [],
      collectMonth: [],
      dataTypes: ['sales'],
      taskType: 'realtime',
      scheduledTime: '',
      splitFile: true,
      compareData: false
    },
    clientList: [], // 存储可选的采集对象列表
    rules: {
      collectTargets: [
        { required: true, message: '请选择采集对象', trigger: 'change' }
      ],
      collectMonth: [
        { required: true, message: '请选择采集月份', trigger: 'change' }
      ],
      dataTypes: [
        { required: true, message: '请选择数据类型', trigger: 'change' }
      ],
      taskType: [
        { required: true, message: '请选择任务类型', trigger: 'change' }
      ],
      scheduledTime: [
        { required: true, message: '请选择定时采集时间', trigger: 'change' }
      ],
      splitFile: false,
      compareData: false
    },
    selectedDealers: [], // 存储选中的经销商
    defaultTime: new Date().toTimeString().slice(0,8),
    scheduledTimeOptions: {
      disabledDate(time) {
        return time.getTime() < Date.now() - 8.64e7; // 禁用今天以前的日期
      }
    },
    loading: false,
  }),
  created() {
    // this._getList(1);
  },

  mounted() {
    this.getenumBusinessList();
  },
  methods: {
    handleTaskTypeChange(value) {
      // 如果是定时任务，设置默认时间为当前时间
      if (value === 'scheduled') {
        this.createTaskForm.scheduledTime = new Date();
        console.log(this.createTaskForm.scheduledTime, 'this.createTaskForm.scheduledTime');
      }
    },
    /**
     * 终止临时抓取任务-弹窗
     */
    onStopDialog(temporaryGrabId) {
      this.stopDialog = true;
      this.temporaryGrabId = temporaryGrabId;
    },

    /**
     * 终止临时抓取任务-弹窗操作
     */
    confirmStopDialog() {
      this.loading = true;
      let parameter = {};
      parameter.temporary_grab_id = this.temporaryGrabId;
      stopTemporary(parameter).then((res) => {
        if (0 === res.status) {
          this.$message({
            message: res.msg,
            type: "success",
          });
        } else {
          this.$message.error(res.msg);
        }
        this.loading = false;
        this.stopDialog = false;
        this._getList(this.currentPage);
      }).catch(() => {
        this.loading = false;
      });
    },

    onSearch() {
      this._getList(1);
    },
    getenumBusinessList() {
      let par = {
        enum_name_arr: [
          "TemporaryGrabStatusEnum",
          "TemporaryGrabReportTypeEnum",
        ],
      };
      enumBusinessList(par).then((res) => {
        if (res.status == 0) {
          let data = res.data;
          for (const iterator of data) {
            for (const key in iterator) {
              if (Object.hasOwnProperty.call(iterator, key)) {
                const element = iterator[key];
                if (key == "TemporaryGrabStatusEnum") {
                  //用本地写死的，后台返回的值不准确
                  this.statusList = [
                    {
                      key: -1,
                      value: "全部"
                    },
                    {
                      key: 3,
                      value: "已完成"
                    },
                    {
                      key: 9,
                      value: "计划中"
                    },
                    {
                      key: 8,
                      value: "抓取失败"
                    },
                    {
                      key: 7,
                      value: "取消任务"
                    },
                    {
                      key: 0,
                      value: "等待中"
                    },
                    {
                      key: 1,
                      value: "处理中"
                    }
                  ];
                } else {
                  this.reportList = element;
                }
              }
            }
          }
          this._getList(1);
        }
      });
    },
    _getList(page) {
      this.tableDataLoading = true;
      let parameter = {};
      parameter = this.form;
      parameter.page = page;
      getqueryPageList(parameter).then((res) => {
        this.tableDataLoading = false;
        if (0 === res.status) {
          const tableData = res.data.list;
          this.totalCount = res.data.totalCount;
          this.currentPage = parseInt(res.data.currentPage);
          this.totalPage = res.data.totalPage;
          for (let item of tableData) {
            switch (item.report_type) {
              case 0:
                item.report_type_label = "连接配置";
                break;
              case 1:
                item.report_type_label = "销售日报";
                break;
              case 2:
                item.report_type_label = "采购日报";
                break;
              case 3:
                item.report_type_label = "库存日报";
                break;
              case 4:
                item.report_type_label = "销售周报";
                break;
              case 5:
                item.report_type_label = "采购周报";
                break;
              case 6:
                item.report_type_label = "库存周报";
                break;
              case 7:
                item.report_type_label = "销售月报";
                break;
              case 8:
                item.report_type_label = "采购月报";
                break;
              case 9:
                item.report_type_label = "库存月报";
                break;
            }
          }
          this.tableData = tableData;
        } else {
          this.tableData = [];
          this.currentPage = 1;
          this.totalCount = 0;
          this.totalPage = 0;
        }
      });
    },
    handleCurrentChange(val) {
      this._getList(val);
    },
    goNewTakse() {
      this.$router.push({ name: "directManageNewTask" });
    },
    viewSql(index, row) {
      this.$alert(row.sql, "查看任务SQL", {
        confirmButtonText: "关闭",
      });
    },
    viewFile(index, row) {
      adminTemporaryDownloadTempFile({ temporary_grab_id: row.temporary_grab_id }).then((res) => {
        if (0 === res.status) {
          let download_url = res.data.download_url;
          window.open(download_url, '_blank');
        } else if(res.status === 1) {
          window.sessionStorage.setItem("upFile", JSON.stringify(row));
          let r = this.$router.resolve({
            name: "originalFileUpFileInquire",
            params: { type: "2" },
          });
          window.open(r.href);
        }
      });
    },
    goImportTask(){
      this.loading = false;
      this.$router.push({name:'directManageBatchImportTask',params:{}})
    },
    goCreateTask() {
      this.loading = false;
      this.createTaskDialogVisible = true;
    },
   
    submitCreateTask() {
      if(this.loading) return; // 防连点
      this.loading = true;
      
      this.$refs.createTaskForm.validate(async (valid) => {
        if (valid) {
          try {
            // 添加定时采集时间验证
            if (this.createTaskForm.taskType === 'scheduled') {
              const now = new Date().getTime();
              const scheduledTime = new Date(this.createTaskForm.scheduledTime).getTime();
              
              if (scheduledTime <= now) {
                this.$message.error('采集开始时间不能早于当前时间');
                this.loading = false;
                return;
              }
            }

            // 构造请求参数
            const parameter = {
              client_list: JSON.stringify(this.selectedDealers.map(dealer => ({
                client_code: dealer.client_code,
                plugin_code: dealer.plugin_code,
                client_name: dealer.client_name,
                client_id: dealer.client_id
              }))),
              collect_start_month: `${this.createTaskForm.collectMonth[0]}-01`,
              collect_end_month: `${this.createTaskForm.collectMonth[1]}-01`,
              report_types: this.createTaskForm.dataTypes.map(type => {
                return type === 'sales' ? '7' : '8';
              }).join(','),
              scrap_time_type: this.createTaskForm.taskType === 'realtime' ? 1 : 2,
              is_split_file: this.createTaskForm.splitFile ? 1 : 0,
              is_diff: this.createTaskForm.compareData ? 1 : 0
            };

            // 如果是定时任务，添加定时时间
            if (parameter.scrap_time_type === 2) {
              parameter.scrap_time = this.createTaskForm.scheduledTime;
            }

            const res = await multipleAddTemporary(parameter);
            
            if (res.status === 0) {
              this.$message.success(res.msg || '创建任务成功');
              this.createTaskDialogVisible = false;
              this._getList(1); // 刷新列表
            } else {
              this.$message.error(res.msg || '创建任务失败');
            }
          } catch (error) {
            console.error('创建任务失败:', error);
            this.$message.error('创建任务失败');
          } finally {
            this.loading = false;
          }
        } else {
          this.loading = false;
        }
      });
    },
    // 打开选择采集对象弹窗
    openSelectDealer() {
      this.$refs.selectCollectTargetModal.open(this.selectedDealers);
    },

    // 处理采集对象选择结果
    handleDealerSelected(dealers) {
      this.selectedDealers = dealers;
      this.createTaskForm.collectTargets = dealers.map(dealer => dealer.client_id);
    },

    // 移除已选择的采集对象
    handleRemoveDealer(dealer) {
      this.selectedDealers = this.selectedDealers.filter(
        item => item.client_id !== dealer.client_id
      );
      this.createTaskForm.collectTargets = this.createTaskForm.collectTargets.filter(
        id => id !== dealer.client_id
      );
    },

    // 弹窗打开时的处理
    handleDialogOpen() {
      // 重置表单
      this.createTaskForm = {
        collectTargets: [],
        collectMonth: [],
        dataTypes: ['sales'],
        taskType: 'realtime',
        scheduledTime: '',
        splitFile: true,
        compareData: false
      };
      // 重置表单验证状态
      if (this.$refs.createTaskForm) {
        this.$refs.createTaskForm.resetFields();
      }
      this.selectedDealers = [];
      
      // 如果是定时任务，设置默认时间为当前时间
      if (this.createTaskForm.taskType === 'scheduled') {
        this.createTaskForm.scheduledTime = new Date();
        console.log(this.createTaskForm.scheduledTime, 'this.createTaskForm.scheduledTime');
      }
    },
  },
  computed: {
    // 判断是否选择了多个月份
    isMultiMonth() {
      return this.createTaskForm.collectMonth && 
             this.createTaskForm.collectMonth.length === 2 &&
             this.createTaskForm.collectMonth[0] !== this.createTaskForm.collectMonth[1];
    },
    
    // 判断是否显示对比差异选项
    showCompareDataOption() {
      return this.createTaskForm.dataTypes.includes('sales');
    }
  },
  watch: {
    // 监听数据类型变化，当取消选择销售月报时，重置对比差异选项
    'createTaskForm.dataTypes'(newVal) {
      if (!newVal.includes('sales')) {
        this.createTaskForm.compareData = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.count_page {
  margin: -10px 0 10px 0;
}
.el-date-picker {
  width: 100%;
}
.selected-dealers {
  min-height: 1px;
}

.el-tag {
  margin-right: 8px;
  margin-bottom: 8px;
}

.el-checkbox {
  .el-checkbox__label {
    color: #666;
    font-size: 13px;
    line-height: 1.4;
  }
}

.new-tag {
  flex-shrink: 0;
  color: white;
  background-color: #409EFF;
  margin-right: 0;
  margin-bottom: 0;
  margin-left: 4px;
}
</style>
